import { combineReducers } from 'redux';
import recommendation from './slices';

const recommendationReducer = combineReducers({
  recommendation,
});

export default recommendationReducer;
